export default "__VITE_ASSET__Dcz$lwbx__"